export default {
  charge_station: {
    name: '监控站',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '充电站名',
      serial_number: '电站编号',
      chargers_count: '桩数量',
      province_id: '省份',
      city_id: '城市',
      district_id: '地区',
      service_provider_id: '运营商',
      operational_staff_id: '专属运营人员',
      address: '地址',
      latitude: '纬度',
      longitude: '经度',
      status: '状态',
      max_power: '设备总功率',
      max_limit_power: '总功率容量上限',
      description: '温馨提示',
      online_chargers_count: '空闲桩数',
      working_chargers_count: '工作中电桩',
      service_provider: '运营商',
      realtime_price: '实时费率',
      created_at: '创建时间',
      updated_at: '更新时间',
      is_public: '是否开放',
      free_parking: '免费停车',
      parking_desc: '停车说明',
      owner: '运营方式',
      realtime: '实时费率',
      billing_rule_complete: '费率是否齐全',
      phone: '联系电话',
      business_hour: '营业时间',
      app_tags: 'App标签',
      chargers: '充电桩',
      comment: '点评',
      note: '平台备注',
      peripheral_facility: '周边配套',
      picture: '图片',
      chargers_status: '桩状态',
      supporting: '配套',
      discount: '参与优惠',
      evcs_sharing: '互联互通',
      yesterday_orders_count: '昨日订单数',
      allow_charging_without_order: '允许无订单启动',
      last_start_time: '最近启动时间',
      power_type: '电源类型',
      allow_periods: '开放时间',
      idle_fee: '占位费规则',
      has_idle_fee: '是否有占位费',
      idle_fee_desc: '占位费说明',
      support_appointment: '支持预约充电',
      discount_type: '优惠类型',
      parking_type: '停车收费类型',
      dc_stop_soc: '直流最高的停止SOC',
      dc_timesharing_stop_socs: '分时的直流停止SOC',
      settlement_discount: '第三方渠道活动',
      settlement_discount_effective_date: '第三方渠道活动生效日期',
      manager: '场站负责人',
      manager_phone: '场站负责人电话',
      charging_standard: '充电标准',
      billing_rule_time_division_type: '桩支持费率类型',
      is_support_update_billing_rule: '支持自定义费率',
      has_stop_soc: '是否有停止SOC',
      station_type: '站类型',
      is_charger_as_charge_point: '枪是否作为充电桩'
    },
    // Enum的属性
    statuses: {
      maintaining: '对内运营',
      available: '对外运营',
      unavailable: '已下架'
    },
    supportings: {
      road_book: '路书',
      parking_lock: '地锁',
      nvr: '摄像头',
      parking_relief: '停车减免',
      charge_after_inserting_gun: '即插即充'
    },
    station_types: {
      public: '公共场站',
      private: '私人站'
    },
    charging_standards: {
      national_standard: '国标',
      european_standard: '欧标'
    },
    is_charger_as_charge_points: {
      true: '是',
      false: '否'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '充电站名称/充电站编号',
      select_discount_type: '会员优惠/社群优惠',
      has_idle_fee: '是否有占位费规则',
      select_operational_staff_id: '请选择专属运营人员',
      select_charging_standard: '请选择充电标准',
      has_stop_soc: '是否有停止SOC'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      charge_points: '充电桩',
      status_history: '电桩状态',
      orders: '订单',
      work_orders: '工单',
      billing_rules: '费率',
      video_monitoring: '视频监控',
      parking_locks: '地锁',
      parking_relief_records: '停车减免记录',
      order_statistics: '订单统计',
      model_version_log_audits: '数据版本日志',
      station_activities: '用户访问日志',
      alarms: '告警',
      discounts: '优惠',
      settlement: '结算记录'
    },
    group_titles: {
      base: '基础信息',
      location: '位置信息',
      business_info: '运营信息',
      road_book: '路书',
      operation: '运营控制'
    },
    titles: {
      update_evcs_operators: '更新互联互通接入平台',
      evcs_operator_options: '可选的平台',
      accessed_evcs_operators: '接入的平台'
    },
    label: '充电站',
    labels: {
      pick_location: '坐标采集',
      available_dc_chargers_count: '空闲直流桩',
      fault_dc_chargers_count: '异常直流桩',
      available_ac_chargers_count: '空闲交流桩',
      occupied_dc_chargers_count: '占用直流桩',
      occupied_ac_chargers_count: '占用交流桩',
      fault_ac_chargers_count: '异常交流桩',
      start_count: '次启动',
      distance: '距离',
      support_appointment: '可预约',
      notsupport_appointment: '不可预约',
      can_start_without_user: '允许无订单启动',
      cannot_start_without_user: '不允许无订单启动'
    },
    btn: {
      edit_billing_rule: '更换费率',
      update_billing_rule: '修改费率',
      send_billing_rule_to_charger: '下发费率到桩',
      new_nvr: '新增监控',
      parking_relief_code: '停车减免二维码'
    },
    tips: {
      business_status_info: '只有「对外运营」的站才会显示到App；「已下架」将不支持 App 启动充电',
      app_not_visible: 'App不可见',
      app_visible: 'App可见',
      ev_charging_station_img: '如需要维护图片信息，请点击右上角「切换到共享站」进行管理',
      success_send_nvr_capture: '已请求更新摄像头视频截图',
      allow_charging_without_order: '平台自动检测，如果发现充电中无订单，则报警并且停止充电',
      setting_evcs_operators: '注意事项: 市政平台请谨慎接入，可能会影响后期补贴申请',
      support_appointment: '当前功能只开放给私人桩，并且只能通过运营端账户预约启动充电',
      soc_range: '范围: 80% ~ 100%',
      station_public: '充电站状态设置为仅对内开放',
      create_group: '自动创建家庭集团，免费充电',
      join_group: '用户（联系人）自动加入到集团'
    },
    billing_rule_dialog: {
      title: '下发费率到充电桩',
      prop: {
        charger_name: '桩名',
        charger_sn: '桩编号',
        charger_status: '桩状态',
        billing_rule_name: '费率',
        send_status: '下发状态'
      },
      btn: {
        send: '确认下发'
      }
    },
    import_charger_dialog: {
      title: '批量导入充电桩',
      prop: {
        choose_station: '选择充电站',
        choose_charger: '选择充电桩'
      },
      sub_title: {
        choose_clone_target: '选择克隆对象',
        upload_import_file: '上传导入文件'
      },
      explanation: {
        instructions: '操作说明：',
        download_file: '根据模板批量导入充电桩，请下载文件',
        form_template: '充电桩导入模板.xlsx',
        import_complete: '并根据列名填写桩名称及编号，填写后保存文件并点击下方“选择导入文件”按钮点选填写好的数据文件完成导入。'
      },
      btn: {
        choose_import_file: '选择导入文件',
        send: '导入数据'
      },
      placeholder: {
        could_search: '可搜索'
      },
      note: {
        max5M: '上传文件不超过5M'
      },
      import_preview_dialog: {
        title: '批量导入预览',
        prop: {
          name: '桩名',
          serial_number: '编号',
          collector_serial_number: '采集器编号',
          plug_types: '品牌',
          rated_voltage: '额定电压',
          rated_current: '额定电流',
          rated_power: '额定功率',
          minimum_turn_on_balance: '最低启动金额',
          minimum_charging_balance: '停止充电余额'
        },
        btn: {
          confirm_import: '确认导入'
        }
      }
    },
    status: {
      available: '对外运营',
      maintaining: '对内运营',
      unavailable: '已下架'
    },
    billing_rule: {
      normal_users_billing_rule: '常规用户费率',
      special_users_billing_rule: '特定群体费率',
      basic_billing_rule: '站常规费率',
      station_day_billing_rule: '高温费率',
      vip_billing_rule: '站会员费率',
      member_day_billing_rule: '会员日费率',
      community_group_billing_rule: '社群优惠费率',
      special_billing_rule: '周期费率',
      applicable_description: '（适用于全部电桩。如果桩有专属费率，则桩费率优先）',
      today_effective: '今日生效'
    },
    discount_types: {
      no_discount: '没有优惠',
      membership: '会员优惠',
      community_group: '社群优惠'
    },
    is_support_update_billing_rules: {
      true: '支持',
      false: '不支持'
    },
    notice_list: {
      notice: '提示'
    },
    owner: {
      self: '自营',
      third_party: '第三方'
    },
    has_idle_fee: {
      true: '有',
      false: '无'
    },
    has_stop_soc: {
      true: '有',
      false: '无'
    },
    player: {
      placeholder: {
        select_play_time: '选择回放的时间'
      },
      btn: {
        play_with_time: '回放',
        live_play: '直播',
        play: '重播',
        stop: '停止'
      },
      tips: {
        empty: '请选择回放/直播',
        traffic: '流量有限，播放完成请主动停止播放 或者 关闭播放页面。尽量不使用高清模式',
        live_playing: '直播',
        record_playing: '回放'
      }
    },
    nvr_channel: {
      name: '视频监控',
      title: {
        update: '视频监控设置'
      },
      tips: {
        picture_delay: '图片非实时，可能存在延迟'
      },
      prop: {
        name: '名称',
        nvr_serial_number: '海康设备序列号',
        channel_number: '海康设备通道号',
        code: '海康验证码',
        autoplay: '自动播放',
        is_muted: '开启音频',
        is_hd: '海康高清视频',
        parking_sys_station_sn: '场站编号',
        parking_sys_camera_sn: '摄像头编号'
      },
      placeholder: {
        input_channelNumber: '设置了验证的视频才需要填写',
        input_parking_sys_station_sn: '车位管理系统上的场站编号',
        input_parking_sys_camera_sn: '车位管理系统上的摄像头编号'
      }
    },
    list_tabs: {
      all: '全部站',
      public_dc: '对外直流',
      public_ac: '对外交流',
      private: '对内运营',
      closed: '已下架'
    },
    batch_modify: {
      titles: {
        select_charge_points_or_chargers: '选择充电桩、枪',
        select_attributes: '选择属性',
        charge_point_list: '充电桩列表',
        charger_list: '充电枪列表'
      },
      labels: {
        type: '属性的来源',
        attribute: '修改的属性',
        no: '序号',
        modify_to: '修改为'
      },
      types: {
        charge_point: '充电桩',
        charger: '充电枪'
      },
      btns: {
        next: '下一步',
        previous: '上一步',
        confirm: '确认修改',
        confirm_and_modify_others: '确认并修改其他属性'
      }
    }
  }
}
